import SubmittedTimeOffRequests from './SubmittedTimeOffRequests';

export default SubmittedTimeOffRequests;
